.card {
  min-height: 360px;
  max-width: 464px;
  width: 100%;
}

.logo {
  display: flex;
  align-items: center;
  margin-bottom: 35px;
  justify-content: center;
}

.title {
  color: var(--color-easil-black);
  font-size: 28px;
}

.columns {
  display: flex;
}

.col {
  padding-right: 32px;
  width: 50%;
  flex: auto;
  border-right: 1px solid var(--color-easil-gray-x-light);
}

.form {
  width: 100%;
}

.form > div ~ div {
  margin-top: 16px;
}

.links {
  display: flex;
  align-items: center;
}

.links a {
  color: var(--color-easil-black);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  font-size: 13px;
  line-height: 21px;
}

.footer a {
  margin: 0px 3px 0px 3px;
  color: var(--color-easil-gray-dark);
}

.login {
  margin-top: 62px;
}

.login a {
  margin: 0px 3px 0px 3px;
  color: var(--color-easil-black);
}

.actions {
  align-content: center;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}
